import { navigationIdentity } from './navigationIdentity';

const destination = (to, key, testid, options = {}) => ({
  ...navigationIdentity(to), to, key, testid, ...options,
});

// One camera-and-log entry point; ordinary /id links still identify only.
export const SNAP_FIND_ROUTE = '/id?then=log';

// Every daily destination, in a stable order and without usage tracking.
export const PRIMARY_NAV = [
  destination('/dashboard', 'nav.home', 'nav-home'),
  destination('/my-garden', 'nav.garden', 'nav-garden'),
  destination('/tasks', 'nav.tasks', 'nav-tasks'),
  destination('/shed', 'menu.shed', 'nav-shed'),
  destination('/garden-doctor', 'nav.doctor', 'nav-doctor'),
  destination(SNAP_FIND_ROUTE, 'finds.snap', 'nav-snap'),
  destination('/eden', 'home.card_eden', 'nav-eden'),
  destination('/harvest', 'menu.harvest', 'nav-harvest'),
  destination('/bed-layout', 'menu.beds', 'nav-beds', { full: true }),
  destination('/weekly-plan', 'menu.weeklyplan', 'nav-weekly-plan'),
  destination('/calendar', 'nav.calendar', 'nav-calendar'),
  destination('/community', 'nav.community_short', 'nav-community', { full: true }),
];

export const PROFILE_NAV = destination('/profile', 'nav.profile', 'nav-profile');

// Six touch targets in Simple and Advanced: Home, Garden, Doctor, Snap,
// Eden, then More. Tasks lead More and remain prominent on the dashboard.
const DOCK_ROUTES = ['/dashboard', '/my-garden', '/garden-doctor', SNAP_FIND_ROUTE, '/eden'];
export const primaryNavigation = () => DOCK_ROUTES.map(route => PRIMARY_NAV.find(item => item.to === route));

export const MORE_NAV_GROUPS = [
  { key: 'nav.explore_tools', items: [
    destination('/discover', 'menu.discover', 'menu-discover'),
    destination('/foraging', 'menu.wild', 'menu-wild'),
    destination('/finds-map', 'finds.my_log', 'menu-finds-map', { requiresMember: true }),
    destination('/mushrooms', 'menu.mushrooms', 'menu-mushrooms'),
    destination('/marketplace', 'menu.marketplace', 'menu-marketplace'),
    destination('/leaderboard', 'menu.leaderboard', 'menu-leaderboard'),
    destination('/achievements', 'menu.achievements', 'menu-achievements'),
  ] },
  { key: 'nav.account_tools', items: [
    destination('/profile', 'nav.profile_settings', 'menu-profile'),
    destination('/premium', 'nav.membership', 'menu-premium'),
    destination('/help', 'menu.help', 'menu-help'),
    destination('/privacy', 'nav.privacy', 'menu-privacy'),
  ] },
];

// Every destination is reachable exactly once: either in the dock or in More.
// Tasks lead the daily tools, then the Shed (recipes, notes, shopping list).
// The recipe chat lives in the Shed, so /recipes is reached from there
// rather than listed twice.
const LEAD = ['/tasks', '/shed'];
const rank = to => (LEAD.includes(to) ? LEAD.indexOf(to) : LEAD.length);

export function moreNavigation() {
  const docked = new Set(primaryNavigation().map(item => item.to));
  const daily = PRIMARY_NAV.filter(item => !docked.has(item.to))
    .sort((a, b) => rank(a.to) - rank(b.to))
    .map(item => ({ ...item, testid: item.testid.replace(/^nav-/, 'menu-') }));
  return [
    { key: 'nav.daily_tools', items: daily },
    ...MORE_NAV_GROUPS.map(group => ({ ...group, items: group.items.filter(item => !docked.has(item.to)) })),
  ];
}
